var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "hub-background",
      staticStyle: { position: "relative" },
      attrs: { "justify-center": "", wrap: "", "fill-height": "" }
    },
    [
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in", appear: "" } },
        [
          _c(
            "v-flex",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.closeAway,
                  expression: "closeAway"
                }
              ],
              staticClass: "ma-3 header",
              staticStyle: { position: "relative" },
              attrs: { xs12: "" }
            },
            [
              _c("div", { staticClass: "logo-badge" }, [
                _c("img", {
                  staticClass: "logo",
                  attrs: { src: require("../assets/logos/weezie_icon.png") }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  key: _vm.showManagementHub,
                  staticClass: "header-item-container"
                },
                _vm._l(_vm.headerItems, function(item) {
                  return _c("header-item", {
                    key: item.route,
                    attrs: {
                      title: item.title,
                      "short-title": item.shortTitle,
                      loading: _vm.loading,
                      route: item.route,
                      "permission-name": item.permissionName,
                      trackingIdentifier: item.permissionName,
                      inactive: item.disabled,
                      redirect: item.redirect,
                      show: item.show,
                      icon: item.icon
                    },
                    on: { click: _vm.toggleManagementHub }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "v-layout",
                {
                  attrs: {
                    row: "",
                    "justify-end": "",
                    "align-center": "",
                    id: "badge"
                  }
                },
                [
                  _c(
                    "v-badge",
                    {
                      staticClass: "notifications-badge",
                      attrs: {
                        content: null,
                        value: _vm.messages.length,
                        color: "red",
                        dot: "",
                        overlap: ""
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: { click: _vm.onNotificationButtonClick }
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "#231E46", size: "24" } },
                            [_vm._v(" notifications_none ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("notifications-window", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.notificationWindow,
                        expression: "notificationWindow"
                      }
                    ],
                    attrs: {
                      top: "75px",
                      right: _vm.width,
                      notificationOpen: _vm.notificationWindow
                    },
                    on: { notifications: _vm.setNotificationNumber }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "hub-user-info-container",
                      attrs: { shrink: "", id: "userInfoContainer" }
                    },
                    [
                      _c("user-button", {
                        attrs: {
                          "show-avatar": false,
                          locationInApp: "hub",
                          avatarWidth: "60px",
                          avatarHeight: "60px"
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.toggleUserWindow.apply(null, arguments)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("user-window", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.userWindow,
                    expression: "userWindow"
                  }
                ],
                attrs: {
                  right: "10px",
                  top: "75px",
                  twoFactorAuthenticationPopUp: false
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { staticClass: "hub-scroll scroll-fire-fox", attrs: { xs11: "" } },
        [
          _c(
            "div",
            {
              key: _vm.showManagementHub
                ? "management-hub-items-container"
                : "hub-items-container",
              class: _vm.showManagementHub
                ? "management-hub-items-container"
                : "hub-items-container",
              style: { height: _vm.showManagementHub ? "97%" : "69%" }
            },
            _vm._l(_vm.mainTiles, function(item) {
              return !item.children
                ? _c("hub-item", {
                    key: item.route,
                    class: item.size,
                    attrs: {
                      title: item.title,
                      description: item.description,
                      route: item.route,
                      "permission-name": item.permissionName,
                      "background-image": item.backgroundImage,
                      loading: _vm.loading,
                      dev: item.dev,
                      inactive: item.disabled,
                      "item-size": item.size,
                      redirect: item.redirect,
                      trackingIdentifier: item.permissionName
                    }
                  })
                : _c(
                    "div",
                    {
                      key: "hub-item-children-container",
                      staticClass: "hub-item-children-container",
                      style: [
                        {
                          height: _vm.showManagementHub ? item.height : "auto"
                        },
                        item.style
                      ]
                    },
                    [
                      item.title
                        ? _c(
                            "div",
                            { staticClass: "hub-item-children-title" },
                            [_vm._v(_vm._s(item.title))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(item.children, function(child) {
                        return _c("hub-item", {
                          key: child.route,
                          class: child.size,
                          attrs: {
                            title: child.title,
                            description: child.description,
                            route: child.route,
                            "permission-name": child.permissionName,
                            "background-image": child.backgroundImage,
                            loading: _vm.loading,
                            dev: child.dev,
                            inactive: child.disabled,
                            "item-size": child.size,
                            redirect: child.redirect,
                            trackingIdentifier: child.permissionName
                          }
                        })
                      })
                    ],
                    2
                  )
            }),
            1
          ),
          _vm._v(" "),
          _vm.secondaryTiles.length > 0
            ? _c(
                "div",
                {
                  key: "secondary-tiles-container",
                  staticClass: "secondary-tiles-container"
                },
                _vm._l(_vm.secondaryTiles, function(item) {
                  return _c("hub-item", {
                    key: item.route,
                    class: item.size,
                    attrs: {
                      title: item.title,
                      description: item.description,
                      route: item.route,
                      "permission-name": item.permissionName,
                      "background-image": item.backgroundImage,
                      loading: _vm.loading,
                      dev: item.dev,
                      inactive: item.disabled,
                      "item-size": item.size,
                      redirect: item.redirect,
                      trackingIdentifier: item.permissionName
                    }
                  })
                }),
                1
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        {
          staticClass: "ma-3",
          staticStyle: { position: "relative", "max-width": "79%" },
          attrs: { xs12: "" }
        },
        [
          _c("hub-footer", {
            attrs: {
              loading: _vm.loading,
              host: _vm.host,
              version: _vm.version
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("loading-spinner", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          color: "accent",
          opacity: 0
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("activate-two-authentication-dialog", {
        attrs: { open: _vm.opened2FArequired },
        on: {
          close: function($event) {
            _vm.opened2FArequired = false
          },
          activateAuthenticate: function($event) {
            _vm.twoFactorAuthentication = true
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-057e282b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057e282b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Hub.vue
// module id = null
// module chunks = 